import {makeAutoObservable} from "mobx";
import {getStore, useStore} from "./index.jsx";


/**
 * 전역 로딩 상태 관리 Store
 */
export class LoadingStore {

    /**
     * 현재 진행 중인 로딩 요청 개수
     * @type {number}
     */
    count = 0;

    /**
     * 로딩 UI 노출 여부
     * @type {boolean}
     */
    visible = false;


    constructor(store) {
        this.store = store;
        makeAutoObservable(this, {}, {autoBind: true});
    }

    /**
     * 로딩 시작 함수
     * 요청 개수를 증가시킴
     */
    startLoading() {
        this.count += 1;
    }


    /**
     * 로딩 상태 변경 함수
     * true일 경우 즉시 로딩 노출
     * false일 경우 요청 개수를 감소시키고
     * 모든 요청이 종료되면 로딩 숨김 처리
     *
     * @param {boolean} value 로딩 상태값
     */
    setLoadingState(value) {
        if(value){
            this.visible = value;
        } else{
            this.count = Math.max(0, this.count - 1);
            if (this.count === 0) {
                this.visible = value;
            }
        }
    }
}

/**
 * LoadingStore Hook
 *
 * @returns {LoadingStore}
 */
export const useLoadingStore = () => {
    return useStore().loadingStore;
}

/**
 * LoadingStore 직접 접근 함수
 *
 * @returns {LoadingStore}
 */
export const getLoadingStore = () => {
    return getStore().loadingStore;
}
